'use client'

import { useEffect, useRef } from "react"
import noUiSlider from 'nouislider'

type RangeSliderProps = {
    min: number,
    max: number,
    rangeMin: number,
    rangeMax: number,
    onChange: Function,
    step?: number,
    unit?: string
}

export default function RangeSlider({
    min,
    max,
    rangeMin, 
    rangeMax,
    onChange,
    step = 50,
    unit = "€"
}: RangeSliderProps) {

    const ref = useRef()
    const refSlider = useRef<any>()

    useEffect(() => {
        const slider = (ref.current as HTMLElement).querySelector(".js-slider");

        if ('noUiSlider' in slider) return

        noUiSlider.create((slider as HTMLElement), {
            start: [min, max],
            step,
            connect: true,
            range: {
                min: rangeMin,
                max: rangeMax
            },
            format: {
                to: function (value: any) {
                    return value;
                },
                from: function (value: any) {
                    return value;
                },
            },
        });

        handleChange()

        refSlider.current = slider['noUiSlider']
    }, [])

    useEffect(() => {
        console.log('onchange')
        if (!refSlider.current) return
        handleChange()
    }, [onChange])

    function handleChange() {
        if (!refSlider.current) return
        const snapValues = [
            (ref.current as HTMLElement).querySelector(".js-lower"),
            (ref.current as HTMLElement).querySelector(".js-upper"),
        ];
        refSlider.current.off('update')
        refSlider.current.on('update', function (values, handle) {            
            snapValues[handle].innerHTML = values[handle] + (unit ? ' ' + unit : '');
            if (values[0] !== min || values[1] !== max) {
                onChange(values)
            }                
        })
    }

    return (
        <>
            <div ref={ref}>
                <div className="text-14 fw-500" />
                <div className="d-flex justify-between mb-20">
                    <div className="text-15 text-primary">
                        <span className="js-lower" /> - <span className="js-upper" />
                    </div>
                </div>
                <div className="px-5">
                    <div className="js-slider" />
                </div>
            </div>
        </>
    )
}